import React from "react";
import { Paper } from "@mui/material";
import { dash } from "./dashboardTokens";

export default function SurfaceCard({ children, loading = false, sx = {}, ...rest }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: dash.cardPadding,
        borderRadius: dash.radiusLg,
        border: `1px solid ${dash.border}`,
        bgcolor: dash.surface,
        boxShadow: dash.shadowSm,
        opacity: loading ? 0.65 : 1,
        transition: `opacity ${dash.transition}, box-shadow ${dash.transition}`,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
}
